import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { DetailsActionContext } from "./DetailsActionContext";
import index from "@beeldit/core/services";

function useGet() {
  const { setElement } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    index("footers/byTenant")
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
